



































































































































import { Component } from 'vue-property-decorator'
import GoalMilestoneMixin from './GoalMilestoneMixin'
import { mixins } from 'vue-class-component'

@Component({})
export default class GoalMilestoneWeb extends mixins(GoalMilestoneMixin) {
  saveGoalAndNavigate(courseId: string) {
    sessionStorage.setItem('previousPage', this.$route.path);

    this.toCourse(courseId);
  }
}
